webpackJsonpUpdateBris([97],{

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CategoryCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'CategoryCarousel';
var CLS = 'categoryCarousel';
var BLK = '.' + CLS + '-';
var SLIDE_TO_SHOW = 4;
var CLS_IS_INITED = 'is-initialized';

var CategoryCarousel = exports.CategoryCarousel = function () {
	function CategoryCarousel(el) {
		_classCallCheck(this, CategoryCarousel);

		this.el = el;
		this.$el = $(el);
		this.$parent = this.$el.parent();
		this.$slider = this.$el.find('.' + CLS + '-slider');
		this.$sliderWrap = this.$el.find('.' + CLS + '-sliderWrap');
		this.$btnNext = this.$el.find('.' + CLS + '-btnNext');
		this.$btnPrev = this.$el.find('.' + CLS + '-btnPrev');

		this.slidesToShow = this.$el.data('slidesToShow');
		if (this.slidesToShow && !isNaN(this.slidesToShow)) {
			this.slidesToShow = parseInt(this.slidesToShow);
		} else {
			// if the value set in the data-slides-to-show attribute
			switch (this.slidesToShow) {
				case 'displaymode-full':
					this.slidesToShow = 4;
					break;
				case 'displaymode-half':
					this.slidesToShow = 3;
					break;
				case 'displaymode-one-third':
					this.slidesToShow = 2;
					break;
				case 'displaymode-two-thirds':
					this.slidesToShow = 3;
					break;
				case 'displaymode-one-quarter':
					this.slidesToShow = 2;
					break;
				case 'displaymode-three-quarters':
					this.slidesToShow = 3;
					break;
			}
		}

		// if the value set in the parent
		if (this.$parent.hasClass('displaymode-full')) {
			this.slidesToShow = 4;
		} else if (this.$parent.hasClass('displaymode-half')) {
			this.slidesToShow = 3;
		} else if (this.$parent.hasClass('displaymode-one-third')) {
			this.slidesToShow = 2;
		} else if (this.$parent.hasClass('displaymode-two-thirds')) {
			this.slidesToShow = 3;
		} else if (this.$parent.hasClass('displaymode-one-quarter')) {
			this.slidesToShow = 2;
		} else if (this.$parent.hasClass('displaymode-three-quarters')) {
			this.slidesToShow = 3;
		}

		this.initCategoryCarousel();
	}

	_createClass(CategoryCarousel, [{
		key: 'initCategoryCarousel',
		value: function initCategoryCarousel() {
			var _breakpoints,
			    _this = this;

			// from mobile to desktop
			var slidesToShow = this.slidesToShow || SLIDE_TO_SHOW;

			var swiper = new Swiper(this.$sliderWrap[0], {
				init: false,
				slidesPerView: 1,
				spaceBetween: 24,
				freeMode: true,
				mousewheel: true,
				navigation: {
					nextEl: this.$btnNext[0],
					prevEl: this.$btnPrev[0]
				},
				breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, utils.BREAKPOINT.XS, {
					slidesPerView: 2
				}), _defineProperty(_breakpoints, utils.BREAKPOINT.SM, {
					slidesPerView: 2
				}), _defineProperty(_breakpoints, utils.BREAKPOINT.MD, {
					slidesPerView: slidesToShow > 2 ? 3 : 2
				}), _defineProperty(_breakpoints, utils.BREAKPOINT.LG, {
					slidesPerView: slidesToShow
				}), _breakpoints)
			});

			swiper.on('init', function () {
				_this.$el.addClass(CLS_IS_INITED);
			});

			swiper.init();
		}

		//Add more functions like on above here

	}]);

	return CategoryCarousel;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-category-carousel-chunk.js